import { TableHeaderGeneric } from 'src/components';
import styled from 'styled-components';

export const TableHeaderCell = styled(TableHeaderGeneric)`
  &:first-child {
    width: 60%;
    padding-left: 20px !important;
  }
`;
